export default __webpack_public_path__ + "static/media/IMG_9954.2eb82b00.webp";